import React, { Component } from 'react';
import { Portal } from 'react-portal';
import ScrollLock from 'react-scrolllock';
import PerfectScrollbar from 'react-perfect-scrollbar'

import ContactForm from './ContactForm';
import CloseIcon from 'Assets/images/icon_close.svg';

import './ProductPopup.module.css';

const KEYCODES = {
  ESCAPE: 27,
};

class ProductPopup extends Component {

  constructor(props) {
    super(props);
    this.portalNode = null;
    this.state = {
      contactFormOpen: false
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeydown);
    document.addEventListener('click', this.handleOutsideMouseClick);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleOutsideMouseClick);
  }

  handleOutsideMouseClick = (e) => {
    const root = this.portalNode.props.node || this.portalNode.defaultNode;
    if (!root || root.contains(e.target) || (e.button && e.button !== 0)) {
      return;
    }
    this.closePortal();
  }

  handleKeydown = (e) => {
    if (e.keyCode === KEYCODES.ESCAPE) {
      this.closePortal();
    }
  }

  closePortal = () => {
    this.props.onClose();
  }

  showForm = () => {
    this.setState((prevState) => {
      return {
        contactFormOpen: !prevState.contactFormOpen
      }});
  }

  render() {

    const documentLabel = this.props.selectedProduct.document_label || 'Broschüre';
    console.log(this.props.selectedProduct);
    let i = 0;
    return (
      <Portal
        key={"react-portal" + (i++)}
        ref={portalNode => (this.portalNode = portalNode)}>
        <div styleName="popup">
          <div styleName="content">
            <a styleName="closeButton" onClick={this.closePortal}>
              <img src={CloseIcon} alt="X"/>
            </a>
            <PerfectScrollbar styleName="scrollableContent"
                 ref={scrollContainer => { this.scrollContainer = scrollContainer }}
            >
              <div styleName={"collapsibleContentContainer" + (this.state.contactFormOpen ? ' collapsed' : '')}>
                <div styleName="fadeOut"></div>
                <h3>{this.props.selectedProduct.brand} {this.props.selectedProduct.name}</h3>
                <p>{this.props.selectedProduct.shortdescription}</p>
                <p>{this.props.selectedProduct.description}</p>
                {this.props.selectedProduct.profile &&  this.props.selectedProduct.profile.length > 0 && (
                  <React.Fragment>
                    <div>Produktprofil:</div>
                    <ul>
                      {
                        this.props.selectedProduct.profile.map((item, index) => (
                          <li key={`${this.props.selectedProduct}-profile-${index}`}>{item.profile}</li>
                        ))
                      }
                    </ul>
                  </React.Fragment>
                )}
                {this.props.selectedProduct.attributes && this.props.selectedProduct.attributes.length > 0 &&
                  <React.Fragment>
                    <div>Eigenschaften/Vorteile:</div>
                    <ul>
                      {

                        this.props.selectedProduct.attributes.map((item, index) => {
                          if (item.attributes) {
                            return <li key={`${this.props.selectedProduct}-attr-${index}`}>{item.attributes}</li>;
                          }
                          return null;
                        })
                      }
                    </ul>
                  </React.Fragment>
                }
              </div>
              <div style={{ paddingTop: '2em', overflow: 'hidden' }}>
                <button onClick={this.showForm}>
                  { this.state.contactFormOpen ? 'Formular schließen' : 'Jetzt kaufen' }
                </button>
                {
                  this.props.selectedProduct.document &&
                    <a href={'https://montadrill.cockpit.localhost.at/storage/uploads/' + this.props.selectedProduct.document.path}
                      target="_blank">
                      {documentLabel} downloaden
                    </a>
                }

              </div>
              <div styleName={"contactForm" + (this.state.contactFormOpen ? ' open' : ' collapsed')}>
                <ContactForm product={this.props.selectedProduct} />
              </div>
            </PerfectScrollbar>
          </div>
        </div>
        <ScrollLock />
      </Portal>
    );
  }

}

export default ProductPopup;



// WEBPACK FOOTER //
// ./src/components/Products/ProductPopup.js